// 产品卡片 变体 product card variant
// let product_block = document.querySelectorAll(".product-block-options ")
// let product_option = document.querySelectorAll(".product-block-options .product-block-options__item ");
// for (let i = 0; i < product_option.length; i++) {
//     let li = product_option[i];
//     (function (j) {
//         product_option[j].onclick = function () {
//             let product_click = product_option[j].parentNode.parentNode.parentNode
//             console.log(product_click)
//             let product_options = product_click.querySelectorAll(".product-block-options__item");
//             for (let j = 0; j < product_options.length; j++) {
//                 product_option[j].classList.remove("active")
//             }
//             product_option[j].classList.add("active")
//         }
//     })(i)
// }

// 移动端 产品卡片
//     let new_adapt_inners = document.querySelectorAll('.new-adapt-product-block .inners');
//     let new_yuan_inner = document.querySelectorAll('.new-adapt-product-block .block-inner');
//     for (let i = 0; i < new_adapt_inners.length; i++) {
//     if (/(iPhone|iPad|iPod|Android|Mobile)/i.test(navigator.userAgent) || window.screen.width < 768) {
//     new_yuan_inner[i].parentNode.removeChild(new_yuan_inner[i])
//     // var script = document.createElement("script");
//     // script.src = "mobile.js";
//     // document.head.appendChild(script);
// } else {
//     new_adapt_inners[i].parentNode.removeChild(new_adapt_inners[i])
// }
// }
class tabCollection extends HTMLElement {
    constructor() {
        super();
        this.newTabList = document.querySelectorAll(".new-tab-title-list li");
        this.newCollectionSection = document.querySelectorAll(".new-tab-collection-section");

    }

    connectedCallback() {
        this.setActiveTab(this.newTabList, this.newCollectionSection);
    }

    setActiveTab(newTabList, newCollectionSection) {
        for (let i = 0; i < newTabList.length; i++) {
            let li = newTabList[i];
            (function (index) {
                newTabList[index].onclick = function (e) {
                    let container = e.srcElement.closest('.new-tab-collection-container')
                    let tab = container.querySelectorAll('.new-tab-title-list li')
                    let section = container.querySelectorAll(".new-tab-collection-section")
                    for (let j = 0; j < tab.length; j++) {
                        tab[j].classList.remove("active")
                        section[j].classList.remove("active")
                    }

                    newTabList[index].classList.add("active")
                    newCollectionSection[index].classList.add("active")
                }
            })(i)
        }
    }


}
customElements.define('tab-collection', tabCollection);

